var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-marker-cluster',{attrs:{"options":_vm.clusterOptions}},_vm._l((_vm.images),function(element){return _c('l-marker',{key:'image-' + element._id,attrs:{"lat-lng":[
      element.datapoint.location.coordinates[1],
      element.datapoint.location.coordinates[0],
    ]},on:{"click":() => _vm.$emit('click:image', element)}},[(element._id === _vm.selected)?_c('l-icon',{attrs:{"icon-url":"/img/fa/solid/fa-image-alt.svg","icon-color":"black","icon-size":[24, 24]}}):_c('l-icon',{attrs:{"icon-url":"/img/fa/solid/fa-image-alt.svg","icon-color":"black","icon-size":[16, 16]}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }